import React from "react";

import Offer_banner from "../../components/UserSideComponents/features/Offer_banner";
// import PgHstlFilter from '../../components/UserSideComponents/features/PgHstlFilter'
import Filterate_room from "../../components/UserSideComponents/features/Filterate_room";

// import "../../../../client/src/App.css"

function Services() {
  return (
    <>
      <Offer_banner></Offer_banner>
      {/* <PgHstlFilter></PgHstlFilter> */}
      <Filterate_room></Filterate_room>
    </>
  );
}

export default Services;
